import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  ENABLED_MODULES_PREFIX,
  PM_FRONTEND_PROPERTIES_KEYS,
  SONY_TOOLS,
  getEnv,
} from '../../config/site.config';
import request from '../../services/request';
import siteConfig from '../../config/site.config';
import { getApiUrl } from '../../config/site.config';
import { SCA_INFO } from '../../config/scaInfo';

const pmAuthBody = {
  username: SONY_TOOLS.AUTH_USERNAME,
  password: SONY_TOOLS.AUTH_PASSWORD,
};

const initialState = {
  sonyToolProp: {
    artifactId: null,
    lastBuildVersionBe: null,
    lastBuildVersionFeWa: null,
    isFeMaInMaintenance: null,
    isFidelityCard: false,
  },
  isInit: true,
  status: 'idle',
  error: null,
};

export const pmFindByIdRes = createAsyncThunk(
  'sonyToolProp/pmFindByIdRes',
  async () => {
    // const responseAuth = await axios.post(
    //   SONY_TOOLS.URL + '/scaAccount/api/v1/authenticate',
    //   pmAuthBody,
    //   {
    //     headers: {
    //       SecretKey: SONY_TOOLS.SECRET_KEY,
    //     },
    //   }
    // );
    // const dataAuth = responseAuth.data.contentData;

    // const response = await axios.get(
    //   SONY_TOOLS.URL +
    //     `/pmFrontendProperties/api/v1/findByCodeAndEnv?code=${SONY_TOOLS.CODE_PM_APPLICATION}&env=${SONY_TOOLS.ENV_PM_APPLICATION}`,
    //   {
    //     headers: {
    //       SecretKey: SONY_TOOLS.SECRET_KEY,
    //       Authorization: 'Bearer ' + dataAuth.accessToken,
    //       'X-Refresh-Token': 'Bearer ' + dataAuth.refreshToken,
    //     },
    //   }
    // );

    // return response.data;
    return SCA_INFO;
  }
);

const sonyToolSlice = createSlice({
  name: 'sonyToolProp',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(pmFindByIdRes.pending, (state, action) => {
        state.status = 'loading';
      })
      .addCase(pmFindByIdRes.fulfilled, (state, action) => {
        state.status = 'success';

        // SET URL PRIVACY POLICY, SOCIAL URL AND STORE URL
        const pmFrontendProperiesMap = {};
        const pmFrontendProperiesEnabledModulesMap = {};

        action.payload.contentData.scaPropertyList.forEach(
          (ithScaProperyItem) => {
            const value = ithScaProperyItem.value;
            const key = ithScaProperyItem.key;
            const upperCaseKey = ithScaProperyItem.key.toLocaleUpperCase();
            const enabledModulesPrefix =
              ENABLED_MODULES_PREFIX.toLocaleUpperCase();

            if (upperCaseKey.startsWith(enabledModulesPrefix)) {
              pmFrontendProperiesEnabledModulesMap[key] = value == 'true';
            } else {
              pmFrontendProperiesMap[key] = value;
            }
          }
        );

        const {
          artifactId,
          lastBuildVersionBe,
          lastBuildVersionFeWa,
          isFeMaInMaintenance,
        } = action.payload.contentData;

        state.sonyToolProp = {
          artifactId: artifactId,
          lastBuildVersionBe: lastBuildVersionBe,
          lastBuildVersionFeWa: lastBuildVersionFeWa,
          isFeMaInMaintenance: isFeMaInMaintenance,
          isFidelityCard:
            pmFrontendProperiesEnabledModulesMap[
              PM_FRONTEND_PROPERTIES_KEYS['enabled.modules.fidelity_points']
            ],
          urlStoreIos:
            pmFrontendProperiesMap[
              PM_FRONTEND_PROPERTIES_KEYS['url_store.ios']
            ],
          urlStoreAndroid:
            pmFrontendProperiesMap[
              PM_FRONTEND_PROPERTIES_KEYS['url_store.android']
            ],
        };
        state.isInit = false;

        if (lastBuildVersionBe && getEnv(siteConfig.profile) !== 'LOCAL') {
          // const baseUrl =
          //   getApiUrl() + '/' + artifactId + '-' + lastBuildVersionBe;
          const baseUrl = getApiUrl();

          request.defaults.baseURL = baseUrl;
        }
      })
      .addCase(pmFindByIdRes.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
        state.isInit = false;
      });
  },
});

export const getSonyToolProp = (state) => {
  return state.sonyToolProp.sonyToolProp;
};
export const getSonyToolIsInit = (state) => {
  return state.sonyToolProp.isInit;
};
export const getIsFidelityCard = (state) => {
  return state.sonyToolProp.sonyToolProp.isFidelityCard;
};
export const getStoreLink = (state) => {
  return {
    urlStoreIos: state.sonyToolProp.sonyToolProp.urlStoreIos,
    urlStoreAndroid: state.sonyToolProp.sonyToolProp.urlStoreAndroid,
  };
};
export default sonyToolSlice.reducer;
